import { FC, PropsWithChildren, useCallback, useMemo } from "react"
import { Form, Input, DatePicker, Button, Select } from 'antd'
import BlockComplex from '@/components/BlockComplex'
import * as api from '@/api/workbench'
import { gztLyOptions } from '@/utils/options'

const Comp = () => {

  const handleApprove = useCallback((row) => {
    window.openInnerPage('/xmk/xmgl/xmk/xmjsNew/kpglNew?fpzt=待开票', '开票管理')
  }, [])

  const columns = useMemo(() => {
    return [
      {
        title: '开票计划编号', 
        width: 150, 
        dataIndex: 'KPJH_DH',
        ellipsis: true,
      },
      { title: '来源', width: 100, dataIndex: 'LY', ellipsis: true },
      { title: '付款方名称', width: 150, dataIndex: 'SKDW', ellipsis: true },
      { title: '开票金额', width: 100, dataIndex: 'KPJE', ellipsis: true },
      {
        title: '操作', 
        width: 60, 
        dataIndex: 'cz', 
        render(text, record) {
          return <Button type="link" onClick={() => handleApprove(record)}>开票</Button>
        }
      }
    ]
  }, [handleApprove])

  return (
    <div className="">
      <BlockComplex
        columns={columns}
        rowKey="KPJH_DH"
        load={api.getCwsxDkp}
        searchForm={
          <>
            <Form.Item
              label="开票计划编号"
              name="kpjhbh"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
            <Form.Item
              label="来源"
              name="ly"
            >
              <Select placeholder="请选择" allowClear>
                {
                  gztLyOptions.map(item => <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>)
                }
              </Select>
            </Form.Item>
            <Form.Item
              label="付款方名称"
              name="fkfmc"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
          </>
        }
      />
    </div>
  )
}

export default Comp
